export function getPublicPath () {
    switch (process.env.PROJECTID) {
    case 'tm-liga-dev':
        return '/liga'
    default:
        return ''
    }
}
